import { getWindowObject } from '@eventbrite/feature-detection';
import { initializeSdk } from '@eventbrite/statsig';

const getDomain = () => {
    return getWindowObject('__SERVER_DATA__')?.env?.ebDomain;
};

export const initializeStatsigSdk = async () => {
    await initializeSdk({
        user: {
            custom: {
                ebDomain: getDomain(),
            },
        },
    });
};
